module.exports = __webpack_public_path__ + "static/img/5008_phase_function_Paper_PointsHejduk_Prediction.dc0abef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5008_phase_function_Paper_PointsHejduk_Prediction.png
// module id = t8R7
// module chunks = 0